import { cn } from '~/utils';
import type { ReactElement } from 'react';
import { AppImage } from './AppImage';

export const BrandLogo = ({
  monochrome = false,
  className,
}: {
  monochrome?: boolean;
  className?: string;
}): ReactElement => (
  <AppImage
    alt="Мыло Студия"
    className={cn(
      'block w-auto max-w-full object-contain',
      "h-8 dark:content-[url('/brand/mylo-studio-logo-dark.png')]",
      monochrome && 'grayscale',
      className
    )}
    draggable={false}
    enableEffect={false}
    fetchPriority="high"
    height="256"
    src="/brand/mylo-studio-logo.png"
    translate="no"
    width="1071"
    wrapperClassName={cn('h-8 w-auto max-w-full', className)}
  />
);
